import { OnDemandEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import Product from "../models/Product";

export const sessionStorageKey = "gc-visitor-bag-products";
export const sessionStorageBagKey = "gc-visitor-bag-key";
export const sessionStorageOrderId = "gc-visitor-order-id";
const checkoutSuccessPath = "/checkout/onepage/success";
const onePageCheckoutPath = "/cart/checkout";

// must be used as a singleton. it will be when used from visitor, because visitor is used as singleton.
export default class Bag {
  constructor(locationPathname) {
    this._locationPathname = locationPathname;
    global.GlamCornerCore.bus.on(OnDemandEvents.CartUpdateProducts, {}, (data) => {
      const { subOrders } = data;
      const products = [];
      subOrders.forEach((subOrder) => {
        subOrder.items.forEach((item) => {
          products.push({
            styleCode: item.styleCode,
            name: item.name,
            designer: item.designer,
            size: item.size,
            price: (item.priceInCents / 100).toString(),
          });
        });
      });
      window.sessionStorage.setItem(sessionStorageKey, JSON.stringify(products));
      window.sessionStorage.setItem(sessionStorageBagKey, data.bagKey);
    });

    global.GlamCornerCore.bus.on(OnDemandEvents.CheckoutPlaceOrderSuccess, {}, (data) => {
      window.sessionStorage.setItem(sessionStorageOrderId, data.id);
    });
  }

  bagKey() {
    if (!(window.GC && window.GC.data && window.GC.data.bagKey)) {
      return window.sessionStorage.getItem(sessionStorageBagKey);
    }

    return GC.data.bagKey;
  }

  getProducts() {
    if (!this._products) {
      this._loadProducts();
      this._clearProductsOnSuccessPage();
    }
    return this._products;
  }

  clear() {
    window.sessionStorage.removeItem(sessionStorageKey);
    window.sessionStorage.removeItem(sessionStorageBagKey);
    window.sessionStorage.removeItem(sessionStorageOrderId);
  }

  orderId() {
    if (this._locationPathname === checkoutSuccessPath) {
      return window.order && window.order.id;
    } else if (this._locationPathname === onePageCheckoutPath) {
      return window.sessionStorage.getItem(sessionStorageOrderId);
    } else {
      return null;
    }
  }

  _loadProducts() {
    if (this._documentHasProducts()) {
      this._loadProductsFromDocument();
      this._storeProductInSessionStorage();
    } else {
      this._loadProductsFromSessionStorage();
    }
  }

  _documentHasProducts() {
    return !!(window.GC && window.GC.data && window.GC.data.products);
  }

  _loadProductsFromDocument() {
    this._products = [];
    window.GC.data.products.forEach((productData) => {
      this._products.push(Product.fromDocumentProductData(productData));
    });
  }

  _loadProductsFromSessionStorage() {
    const productJson = window.sessionStorage.getItem(sessionStorageKey);
    if (productJson) {
      this._products = JSON.parse(productJson).map((data) => Product.fromStorage(data));
    } else {
      this._products = [];
    }
  }

  _storeProductInSessionStorage() {
    window.sessionStorage.setItem(sessionStorageKey, this._productsJson());
  }

  _productsJson() {
    return JSON.stringify(this._products.map((product) => product.forStorage()));
  }

  _clearProductsOnSuccessPage() {
    if (this._locationPathname === checkoutSuccessPath) {
      this.clear();
    }
  }
}
